import { ExerciseType } from '../../../../config/api/models/Exercise';
import { LTISettings } from './types';
import apiRoutes from '../../../../config/api/routes';

export const ltiResponseMapper = (response: any) => response;

export const ltiSettingsByType: Record<ExerciseType, LTISettings> = {
  h5p: {
    url: process.env.REACT_APP_WEZOOZ_H5P_URL as string,
    apiRoute: (exerciseId: string, deepLinking: boolean) => apiRoutes.h5p(exerciseId, deepLinking),
    duplicationApiRoute: apiRoutes.h5pDuplicate,
  },
  book_widget: {
    url: process.env.REACT_APP_WEZOOZ_BOOKWIDGET_URL as string,
    apiRoute: apiRoutes.bookWidgets,
  },
  algebra_kit: {
    url: process.env.REACT_APP_API_ROOT_V2 as string,
    apiRoute: (exerciseId: string) => apiRoutes.algebrakit(exerciseId),
  },
  text_exercise: {
    url: '',
    apiRoute: () => '',
  },
};
